import { createTheme } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface Theme {
    status: {
      danger: string;
    };
  }
  // allow configuration using `createTheme()`
  interface ThemeOptions {
    status?: {
      danger?: string;
    };
  }
}


export const customTheme = createTheme({
  palette: {
    primary: {
      main: '#000000',
    },
    background: {
      paper: '#f2f5f6',
    },
  },
  components: {
    MuiAlert: {
      styleOverrides: {
        standardInfo: {
          backgroundColor: '#fff',  // Hintergrundfarbe der info Alerts
          color: '#424242',           // Schriftfarbe der info Alerts
          '& .MuiAlert-icon': {
            color: '#424242', // Icon-Farbe überschreiben
          },
        },
      },
    },
  },
  shape: {
    borderRadius: '10px',
  },
});
